<template>
  <div>
    <Breadcrumb v-if="$vuetify.breakpoint.mdAndUp"/>

    <BreadcrumbMobile v-if="$vuetify.breakpoint.smAndDown" :breadcrumbs="breadcrumbs"/>

    <v-layout row wrap>
      <v-flex :class="{'xs12 sm2 pt-2': $vuetify.breakpoint.smAndUp, 'xs12 sm12 pt-2': $vuetify.breakpoint.smAndDown}" hidden-xs-only>
        <v-flex v-for="benefit_type in types" :key="benefit_type.name">
          <v-btn
            depressed
            :color="benefit_type.name.toLowerCase() == benefit.benefit_type ? '#638d37' : 'white'"
            block
            class="btn-primary-security text-14-security"
            :class="benefit_type.name.toLowerCase() == benefit.benefit_type ? 'white--text font-weight-bold' : ''"
            @click="goTo(benefit_type.name.replace(/\s/g, '_').toLowerCase())"
          >{{ benefit_type.name }}</v-btn>
        </v-flex>
      </v-flex>
      <v-flex :class="{'xs12 sm9 pl-4 pt-2': $vuetify.breakpoint.smAndUp, 'xs12 sm12 pt-2': $vuetify.breakpoint.smAndDown}">
        <BenefitCard 
          :key="benefit.id" 
          :benefit="benefit" 
          :next="benefit.next_id" 
          :prev="benefit.prev_id"
        />
        
        <v-layout row wrap>
          <v-btn flat @click="goToBenefitList()">
            <!-- <i class="material-icons">navigate_before</i> -->
            <v-avatar size="25" style="background-color: #638d37">
              <img class="arrow-left" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/arrow-left-solid.svg" alt="">
            </v-avatar> 
            <span class="pl-2 font-weight-bold">
              Volver
            </span>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import BenefitButton from "./BenefitButton"
import BenefitCard from "./BenefitCard"
import Breadcrumb from "@/components/General/Breadcrumb";
import BreadcrumbMobile from "@/components/General/BreadcrumbMobile";
export default {
  data() {
    return {
      breadcrumbs: [
        { name: "Inicio", link: "/"},
        { name: "Beneficios", link: "/beneficios"},
      ]
    };
  },
  components: {
    Breadcrumb,
    BreadcrumbMobile,
    BenefitButton,
    BenefitCard
  },
  props: {
    benefit: {
      type: Object,
      required: false
    },
    types: {
      required: true
    }
  },
  mounted(){
    // Manda el scroll al inicio cada vez que se cambia de ruta
    window.scrollTo(0, 0);
  },
  computed: {
    ...mapState("user", ["current_user"]),
    ...mapState("benefits", ["selectedBenefit"]),
    ...mapGetters("benefits", ["getBenefits"])
  },
  methods: {
    ...mapMutations("benefits", ["setBenefit"]),
    ...mapActions("benefits", ["changeBenefitTypeScroll"]),
    goToBenefitList() {
      this.$router.push("/beneficios");
    },
    goTo(element_id) {
      this.changeBenefitTypeScroll(element_id);
      this.$router.push("/beneficios");
    },
    getBenefitGroup(benefit_group) {
      let benefits = this.getBenefits;
      let filtered = benefits.filter(benefit => benefit.name === benefit_group);
      return filtered[0].benefits;
    }
  }
};
</script>
<style lang="css" scoped>
  .v-btn--active:before, .v-btn:hover:before, .v-btn:focus:before {
    background-color: #FFF;
  }
  .arrow-left{
    filter: invert(100%) sepia(0%) saturate(7492%) hue-rotate(105deg) brightness(100%) contrast(96%);
    width: 15px;
  }
</style>
